import { UploadIconSVG } from "../../assets/icon/svg";

interface Props {
    length: number;
    isDragging: boolean;
    onDragOver: (e: React.DragEvent<HTMLLabelElement>) => void;
    onDragLeave: (e: React.DragEvent<HTMLLabelElement>) => void;
    onDrop: (e: React.DragEvent<HTMLLabelElement>) => void;
    onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isDisabled?: boolean;
}

export default function UploadArea({ isDisabled = true, length, isDragging, onDragOver, onDragLeave, onDrop, onFileChange, }: Props) {

    if (length > 0) return null;

    return (
        <>
            {length === 0 && (
                <label
                    onDragOver={onDragOver}
                    onDragLeave={onDragLeave}
                    onDrop={onDrop}
                    className={`
                group flex flex-col items-center justify-center
                rounded-lg border-2 border-dashed
                px-6 py-8 transition-all
                ${
                    !isDisabled
                        ? "cursor-not-allowed border-gray-200 bg-gray-100"
                        : isDragging
                            ? "cursor-pointer border-[#186cb2] bg-blue-50"
                            : "cursor-pointer border-gray-300 bg-gray-50 hover:border-[#186cb2] hover:bg-blue-50"
                }
            `}
                >
                    {/* Upload SVG */}
                    <UploadIconSVG/> 
                    <p className="text-sm font-semibold text-gray-700">Drag & drop files here</p>
                    <p className="text-xs text-gray-500">or click to browse</p>
                    <p className="text-[11px] text-gray-400">Folders are not allowed</p>
                    <input
                        type="file"
                        multiple
                        className="hidden"
                        disabled={!isDisabled}
                        onChange={onFileChange}
                    />
                </label>
            )}
        </>
    )
}
